module.exports = __webpack_public_path__ + "img/item_bookCover_15.a9a731a1.jpeg";